export function CustomSizeField() {
  return (
    <div className="custom-size-field">
      <label data-en="Custom Size" data-ar="الحجم المخصص" htmlFor="customSize">Custom Size</label>
      <input
        className="custom-size-input"
        data-placeholder-ar="مثال: 120 × 200 مم"
        data-placeholder-en="e.g. 120 x 200 mm"
        id="customSize"
        name="customSize"
        placeholder="e.g. 120 x 200 mm"
        type="text"
      />
    </div>
  );
}
